const resources = {
    relatedContentLabel: 'Contenu relié'
};

module.exports = function getResource(label) {
    return resources[label];
};
